module.exports = __webpack_public_path__ + "img/fotolienzo.4c8cd28a.jpg";